export const ADD_SUCCESS = 'Новый OCPI Хаб добавлен';
export const ADD_ERROR = 'Не удалось добавить OCPI Хаб';
